var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "#EB3000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9297 38.96V34.24L32.0097 23.52C32.9164 22.72 33.5564 21.9667 33.9297 21.26C34.303 20.5533 34.4897 19.8933 34.4897 19.28C34.4897 18.4 34.3097 17.62 33.9497 16.94C33.5897 16.2467 33.083 15.7067 32.4297 15.32C31.7764 14.92 31.0097 14.72 30.1297 14.72C29.2097 14.72 28.3964 14.9333 27.6897 15.36C26.9964 15.7733 26.4564 16.3267 26.0697 17.02C25.683 17.7 25.503 18.44 25.5297 19.24H19.9297C19.9297 17.2667 20.363 15.56 21.2297 14.12C22.0964 12.68 23.303 11.5667 24.8497 10.78C26.3964 9.99333 28.1964 9.6 30.2497 9.6C32.1297 9.6 33.8097 10.0133 35.2897 10.84C36.783 11.6533 37.9564 12.7933 38.8097 14.26C39.663 15.7267 40.0897 17.4267 40.0897 19.36C40.0897 20.7867 39.8897 21.9733 39.4897 22.92C39.0897 23.8533 38.4964 24.72 37.7097 25.52C36.923 26.3067 35.9564 27.2 34.8097 28.2L27.0097 35.04L26.5697 33.84H40.0897V38.96H19.9297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 51.0059C25.5612 43.2841 14.25 46.3057 14.25 53.8932C14.25 62.4208 25.9908 65.4424 29.9282 73.3657L29.9998 73.5L30.0714 73.3657C34.0089 65.4424 45.7497 62.4208 45.7497 53.8932C45.8213 46.3057 34.4384 43.2841 29.9998 51.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2H);
export default __webpack_public_path__ + "static/media/2h.54cb3928aadd0651c813c90493680d49.svg";
export { ForwardRef as ReactComponent };